// import $ from 'jquery';
import debug from 'debug';

import Flickity from 'flickity';

const log = debug('fus078/components/sliders');

$(() => {
	const $elements = $('[data-flickity]');
});



// WEBPACK FOOTER //
// ./client/src/site__fus078/components/sliders/index.js